<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div class="_idGenPageitem-2">
<img alt="spuse calls" class="_idGenPageitem-1" src="image/titlepage.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// spousecalls.vue?380e7224